import { isValidEmailAddress } from '../functions';

$(document).ready(function() {
    const forgotPassword = {
        isLoadingForgot: false,
        init() {
            $(document).on('click', '#forgot-btn', this, this.forgotPasswordClick);
        },
        forgotPasswordClick(event) {

            event.preventDefault();
            event.stopImmediatePropagation();
            const _this = event.data;
            
            
            if (_this.isLoadingForgot) {
                return false;
            }
    
            $('#forgot-form').find('.form-error-msg').html('');
            $('#forgot-form').find('.has-error').removeClass('has-error');
    
            var errorsFields = false;
            var errorsEmailInvalid = false;

            if($('#forgot_email').val() == '') {
                errorsFields = true;
                $('#forgot_email').parent().addClass("has-error");
            } else if(!isValidEmailAddress($('#forgot_email').val())) {
                errorsEmailInvalid = true;
                $('#forgot_email').parent().addClass("has-error");
            }
            if (errorsFields) {
                $('#forgot-form').find(".form-error-msg").html("נא למלא את כל השדות המסומנים").attr('role', 'alert');
                return false;
            } else if(errorsEmailInvalid) {
                $('#forgot-form').find(".form-error-msg").append("<div>נא למלא שדה אימייל תקין</div>").attr('role', 'alert');
                $('#forgot_email').focus();
                return false;
            }
    
            //Loading...
            _this.isLoadingForgot = true;
            $('#forgot-btn').append('<i class="fa fa-spinner fa-spin" style="margin-right: 20px"></i>');
    
            var values = '_token=' + $('#_token_forgot').val();
            values += '&email=' + $('#forgot_email').val();
            $.ajax({
                type: "POST",
                url: `${baseURL}/password/email`,
                data: values,
                success: function(response) {
                    _this.isLoadingForgot = false;
                    $('#forgot-btn').find('i').remove();
    
                    if (response.status == 0) {
                        var errorHtml = '';
                        for(var errorKey in response.errors) {
                            if(!response.errors.hasOwnProperty(errorKey)) continue;
                            for(var error in response.errors[errorKey]) {
                                $("#forgot_"+errorKey).parent().addClass('has-error');
                                errorHtml += response.errors[errorKey][error] + '<br>';
                            }
                        }
    
                        $('#forgot-form').find(".form-error-msg").html('<div>'+errorHtml+'</div>').attr('role', 'alert');
                        return false;
                    }
    
                    if (response.status == 1) {
    
                        $('#forgot-form').find('.form-control').val('');
                        $('#passModal').find(".form-error-msg").html('<span class="green">מייל אזכור סיסמה נשלח לכתובת הדוא"ל שלך</span>').attr('role', 'alert');
                        setTimeout(function () {
                            $('#passModal').find(".form-error-msg").html('');
                            $('#passModal').modal('hide');
                        }, 1500);
                        return false;
                    }
    
                    $('#passModal').find(".form-error-msg").html('<div>שגיאה: משהו השתבש, אנא צור קשר עם מנהל מערכת</div>').attr('role', 'alert');
                },
                error(error) {
                    _this.isLoadingForgot = false;
                    $('#forgot-btn').find('i').remove();
                    $('#passModal').find(".form-error-msg").html('<span>הפרטים הזנת אינם תקינים<br />אנא בדוק אותם ונסה שנית</span>').attr('role', 'alert');
                }
            });
        }

    };

    if ($('#passModal').length) {
        forgotPassword.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/forgot.js